const FinalCTA = () => (
  <section
    id="contact"
    className="relative py-28 overflow-hidden"
    style={{ background: 'linear-gradient(135deg, #06111F 0%, #0D2645 38%, #0A1F3A 65%, #051018 100%)' }}
  >
    {/* Cyan orb top-right */}
    <div
      className="absolute top-0 right-0 w-[520px] h-[520px] rounded-full pointer-events-none"
      style={{
        background: 'radial-gradient(circle, rgba(0,217,255,0.18) 0%, transparent 70%)',
        transform: 'translate(30%, -30%)',
      }}
    />
    {/* Blue orb bottom-left */}
    <div
      className="absolute bottom-0 left-0 w-[420px] h-[420px] rounded-full pointer-events-none"
      style={{
        background: 'radial-gradient(circle, rgba(0,80,180,0.22) 0%, transparent 70%)',
        transform: 'translate(-30%, 30%)',
      }}
    />

    {/* Subtle diagonal grid lines */}
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        backgroundImage:
          'repeating-linear-gradient(45deg, transparent, transparent 80px, rgba(0,217,255,0.03) 80px, rgba(0,217,255,0.03) 81px)',
      }}
    />

    {/* Top accent line */}
    <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#00D9FF]/60 to-transparent" />

    {/* Heading */}
    <div className="relative z-10 max-w-3xl mx-auto px-6 text-center scroll-reveal">
      <h2 className="text-4xl lg:text-6xl font-black text-white leading-tight mb-6">
        Ready to Power<br />
        <span className="text-[#00D9FF] [text-shadow:0_0_40px_rgba(0,217,255,0.4)]">Your Project?</span>
      </h2>
    </div>

    {/* Estimate form */}
    <div id="estimate-form" className="relative z-10 max-w-2xl mx-auto mt-16 px-6 scroll-reveal scroll-delay-2">
      <div
        className="backdrop-blur-xl border border-white/10 rounded-2xl p-8 lg:p-10"
        style={{ background: 'rgba(13, 30, 55, 0.7)' }}
      >
        <h3 className="text-2xl font-black text-white mb-2">Request a Free Estimate</h3>
        <p className="text-[#8BAFC8] text-[14px] mb-8">Fill out the form and we&apos;ll get back to you within 1 business day.</p>

        <form
          data-readdy-form
          id="estimate-form-main"
          action="https://readdy.ai/api/form/d72j60kij602egd95jag"
          method="POST"
          className="flex flex-col gap-5"
          onSubmit={async (e) => {
            e.preventDefault();
            const form = e.currentTarget;
            const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
            const statusEl = form.querySelector('#form-status') as HTMLElement;

            const formData = new URLSearchParams();
            new FormData(form).forEach((val, key) => formData.append(key, val as string));

            btn.disabled = true;
            btn.textContent = 'Sending...';

            try {
              const res = await fetch('https://readdy.ai/api/form/d72j60kij602egd95jag', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formData.toString(),
              });
              if (res.ok) {
                statusEl.textContent = "Thanks! We'll be in touch soon.";
                statusEl.className = 'mt-3 text-[#00D9FF] text-sm font-semibold';
                form.reset();
              } else {
                throw new Error('Error');
              }
            } catch {
              statusEl.textContent = 'Something went wrong. Please call us directly.';
              statusEl.className = 'mt-3 text-red-400 text-sm font-semibold';
            } finally {
              btn.disabled = false;
              btn.textContent = 'Submit Request';
            }
          }}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-[12px] font-semibold text-[#A8C4DC] uppercase tracking-wider mb-2">Full Name *</label>
              <input
                type="text"
                name="full_name"
                required
                placeholder="John Smith"
                className="w-full bg-white/5 border border-white/10 focus:border-[#00D9FF]/50 focus:ring-1 focus:ring-[#00D9FF]/30 text-white placeholder-white/40 rounded-lg px-4 py-3 text-sm outline-none transition-all duration-200"
              />
            </div>
            <div>
              <label className="block text-[12px] font-semibold text-[#A8C4DC] uppercase tracking-wider mb-2">Phone *</label>
              <input
                type="tel"
                name="phone"
                required
                placeholder="(269) 555-0100"
                className="w-full bg-white/5 border border-white/10 focus:border-[#00D9FF]/50 focus:ring-1 focus:ring-[#00D9FF]/30 text-white placeholder-white/40 rounded-lg px-4 py-3 text-sm outline-none transition-all duration-200"
              />
            </div>
          </div>

          <div>
            <label className="block text-[12px] font-semibold text-[#A8C4DC] uppercase tracking-wider mb-2">Email</label>
            <input
              type="email"
              name="email"
              placeholder="john@email.com"
              className="w-full bg-white/5 border border-white/10 focus:border-[#00D9FF]/50 focus:ring-1 focus:ring-[#00D9FF]/30 text-white placeholder-white/40 rounded-lg px-4 py-3 text-sm outline-none transition-all duration-200"
            />
          </div>

          <div>
            <label className="block text-[12px] font-semibold text-[#A8C4DC] uppercase tracking-wider mb-2">Service Needed *</label>
            <select
              name="service"
              required
              className="w-full bg-[#0A1628] border border-white/10 focus:border-[#00D9FF]/50 text-white rounded-lg px-4 py-3 text-sm outline-none transition-all duration-200 cursor-pointer"
            >
              <option value="">Select a service...</option>
              <option value="New Construction Wiring">New Construction Wiring</option>
              <option value="Residential Service & Repair">Residential Service &amp; Repair</option>
              <option value="Generator Installation">Generator Installation</option>
              <option value="EV Charger Installation">EV Charger Installation</option>
              <option value="Solar & Panel Upgrade">Solar &amp; Panel Upgrade</option>
              <option value="Specialty Lighting">Specialty Lighting</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div>
            <label className="block text-[12px] font-semibold text-[#A8C4DC] uppercase tracking-wider mb-2">Project Description</label>
            <textarea
              name="description"
              rows={4}
              maxLength={500}
              placeholder="Tell us about your project or issue..."
              className="w-full bg-white/5 border border-white/10 focus:border-[#00D9FF]/50 focus:ring-1 focus:ring-[#00D9FF]/30 text-white placeholder-white/40 rounded-lg px-4 py-3 text-sm outline-none transition-all duration-200 resize-none"
            />
          </div>

          <button
            type="submit"
            className="w-full py-4 bg-[#00D9FF] hover:bg-[#00c5e8] text-[#0A1628] font-black text-[14px] uppercase tracking-widest rounded-lg transition-all duration-300 hover:shadow-[0_0_32px_rgba(0,217,255,0.45)] hover:-translate-y-0.5 cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Submit Request
          </button>
          <p id="form-status" className="hidden" />
        </form>
      </div>
    </div>
  </section>
);

export default FinalCTA;
